import React, { useState } from 'react';
import Chevron from 'assets/icons/chevron-right.svg';
import { classnames, isWindowDefined } from 'helpers/utils';
import * as styles from './indexed-content.module.scss';

export interface IndexContent {
  iTitle: string;
  id: number;
}

type IndexesType = {
  title?: string
  indexes: IndexContent[]
  onIndexClick: (index: number) => void;
};

const Indexes = ({ indexes, onIndexClick, title }: IndexesType) => {
  const desktop = isWindowDefined && window.innerWidth >= 1024;
  const [isExpanded, setIsExpanded] = useState(desktop);

  const handleTitleClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.indexContent}>
      <div className={styles.indexes}>
        <button onClick={handleTitleClick} className={classnames(styles.indexButton, styles.expandSectionButton, isExpanded ? styles.expanded : '')}>
          <span className={styles.indexTitle}>{title}</span>
          <Chevron className={classnames(styles.indexTitleIcon, isExpanded ? styles.expanded : '')} />
        </button>
        {isExpanded && indexes.map(({ iTitle, id }) => (
          <div className={styles.indexItem} key={id}>
            <Chevron />
            <button
              onClick={() => onIndexClick(id)}
              className={styles.indexText}
            >
              {iTitle}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Indexes;
